

<div>


  <div class="container-fluid">
    <footer class="align-items-center border-top flex-column-reverse flex-md-row footer-1 gap-3 gap-md-0 justify-content-around pb-5 pt-4 row row-cols-5">

      <div class="col-2 m-w-lg-auto p-0 w-auto">
        <div class="text-center text-lg-end">
            <div class="copy-text-style d-flex gap-1 m-0">
              {{ "copy_right" | translate: "footer" }}
              <span>©</span>
              <span>{{ site_name }}</span>
              <span>{{ current_year }}</span>
            </div>
        </div>
      </div>


      <!-- payment types -->
      <div class="col-5 m-w-lg-auto mt-lg-0 p-0">
        <div class="d-flex gap-4 justify-content-center flex-wrap">

            <!-- <div class="footer-2-logos-box-style" *ngFor="let type of payment_types;">
              <a href="javascript: void(0);" *ngIf="type?.photo">
                <img src="{{ type?.photo }}" class="footer-1-icon-style">
              </a>
            </div> -->

        </div>
      </div>

      <div class="col-5 m-w-lg-auto w-auto mt-lg-0">
        <ul class="gap-3 justify-content-center justify-content-lg-end me-0 me-lg-5 nav">

          <!-- FAQ -->
          <li class="nav-item mb-2">
            <a
            href="#"
            class="nav-link p-0 text-muted footer-nav-item"
            routerLink="/static-page/FAQ"
            (click)="scroll_to_top();"
            >
              {{ "faq" | translate: "static_pages" }}
            </a>
          </li>


          <!-- all static pages -->
          <li *ngFor="let page of static_pages" class="nav-item mb-2">
            <a
            href="#"
            class="nav-link p-0 text-muted footer-nav-item"
            routerLink="/static-page/info/{{ page?.name_en }}/{{lang}}"
            (click)="scroll_to_top();"
            >
              {{ lang == 'en' ?  page?.name_en : page?.name_ar }}
            </a>
          </li>


        </ul>
      </div>


    </footer>
  </div>


  <div class="text-center mb-4">

    <a
    href="https://codesroots.com/"
    class="link-dark text-decoration-none fs-6 fw-light"
    target="_blank"
    >{{ "made_with" | translate: "footer" }}</a>

  </div>


</div>
